import { useTranslation } from 'react-i18next';

import { Badge } from '@/common/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/common/components/ui/tooltip';

import { BillingStatus } from '../types/SortTypes';

export const STATUS_TO_CLASS_MAP: Record<BillingStatus, string> = {
  PENDING_VALIDATION:
    'rounded-md text-xxs text-utility-blue-light-700 border border-utility-blue-light-200 bg-utility-blue-light-50',
  COMPLETED:
    'rounded-md text-xxs text-utility-success-700 border border-utility-success-200 bg-utility-success-50',
  NOT_COMPLETED:
    'rounded-md text-xxs text-red-700 border border-red-200 bg-red-50',
  IN_PROGRESS:
    'rounded-md text-xxs text-yellow-700 border border-yellow-200 bg-yellow-50',
};

const GREYED_OUT_CLASS =
  'rounded-md text-xxs text-gray-400 border border-gray-200 bg-gray-50';

interface Props {
  status: BillingStatus;
  greyedOut?: boolean;
}

export const BillingStatusBadge = ({ status, greyedOut = false }: Props) => {
  const { t } = useTranslation();
  const className = greyedOut ? GREYED_OUT_CLASS : STATUS_TO_CLASS_MAP[status];

  if (greyedOut)
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Badge className={className}>{t('IN_PROGRESS')}</Badge>
          </TooltipTrigger>
          <TooltipContent>
            <p>{t('billing.drawer.openByDifferentUser')}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );

  return <Badge className={className}>{t(status)}</Badge>;
};
